import { RequestConfig } from '@/interface'
import applicationConfig from './application'
import firmConfig from './firm'
import roleConfig from './role'
import accountConfig from './account'
import logConfig from './log'
import mailboxConfig from './mailbox'
import invoiceConfig from './invoice-config'

const adminConfig: RequestConfig = {
  ...applicationConfig,
  ...firmConfig,
  ...roleConfig,
  ...accountConfig,
  ...logConfig,
  ...mailboxConfig,
  ...invoiceConfig
}
export default adminConfig
